module.exports = __webpack_public_path__ + "static/media/logo-black.9d249fc4.png";